import styled from "styled-components";

export const FestivalCompetitionBannerWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const FestivalCompetitionBannerText = styled.div`
  position: absolute;
  left: 16px;
  bottom: 30px;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 2px;

  > .title {
    font-weight: 700;
    font-size: 24px;
  }

  > .subTitle {
    margin-top: 2px;
    font-weight: 500;
    font-size: 14px;
  }
`;

export const FestivalCompetitionBannerAddress = styled.div<{
  duration: number;
}>`
  background: #6436e7;
  width: 98px;
  height: 30px;
  border-radius: 8px;
  gap: 4px;
  display: flex;
  overflow: hidden;
  position: relative;
  font-weight: 600;
  font-size: 12px;

  > .rolling-track {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    > .rolling-text {
      display: flex;
      animation: ${({ duration }) => `rolling ${duration}s linear infinite`};
      white-space: nowrap;

      > div {
        margin-right: 8px;
      }

      @keyframes rolling {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-50%);
        }
      }
    }
  }
`;

export const FestivalCompetitionImageBanner = styled.div`
  position: relative;
  width: 100%;
  height: 360px;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  > .back {
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
    background: linear-gradient(
      180deg,
      rgba(18, 18, 18, 0) 51.08%,
      #121212 85.49%
    );
  }
`;
export const RabbitFestivalCompetitionScrollingWrapper = styled.div<{
  duration: number;
  $isVisible?: boolean;
}>`
  background: #6436e7;
  width: 100%;
  height: 40px;
  overflow: hidden;
  position: relative;

  > .scroll {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    padding: 5px 0;
    white-space: nowrap;
    animation: ${({ duration, $isVisible }) =>
      $isVisible ? `scroll-x ${duration}s linear infinite` : "none"};

    > img {
      height: 25px;
      object-fit: contain;
      flex-shrink: 0;
      margin-right: 10px;
    }
  }

  @keyframes scroll-x {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-33.33%); /* 3배로 확장했으므로 1/3만큼 이동 */
    }
  }
`;
